<template>
  <v-card
    max-width="650"
    class="mx-auto"
  >
    <v-card-title primary-title>
      <span class="text-h4">
        Löpsedlar
      </span>
    </v-card-title>       
    <v-spacer /> 
    
    <v-card-subtitle class="text-subtitle-2">
      <h5>Får ni rätt antal löpsedlar från Kvällstidningarna?</h5>
      
      Har ni inte nytta av alla löpsedlar ni får kan ni minska upplagan och har ni löpsedelstavlor som hänger tomma i onödan kan ni öka upplagan.<br>
      En löpsedel sätts upp utanför butiken för att visa att det har kommit färska nyheter och hjälper dig att öka försäljningen, vilket genererar mer pengar.<br>
      Du kan välja hur många löpsedlar du vill ha för varje tidning. Skriv in det nya antalet löpsedlar du behöver, så ser vi till att du får det antalet framöver.<br>
      Behöver du löpsedelsmaterial (till exempel löptavla eller plastskivor) klicka in på webbshopen.<br>
    </v-card-subtitle>
    <v-card-text>                 
      <v-list two-lines>
        <v-list-item v-for="l in lop.placards" :key="l.titleId">
          <v-list-item-content>
            <v-list-item-subtitle class="text-subtitle-2">
              Ni får {{ l.amount }} st löpsedlar för {{ l.paper }}, är det korrekt? <br>Skriv in det antal ni önskar.
            </v-list-item-subtitle> 
            <v-list-item-title class="red--text bold">
              <v-text-field
                v-model.number="l.newAmount"
                label="Antal"
                suffix="st"
                validate-on-blur   
                :hint="`Önskat antal löpsedlar för ${ l.paper }`" 
                :rules="[rules.notNull(l)]"
              />
            </v-list-item-title>           
          </v-list-item-content>
        </v-list-item>        
      </v-list>      
      <v-btn color="primary" 
             :loading="saving"            
             @click="spara()"
      >
        Spara
      </v-btn>
    </v-card-text>
    <v-alert
      transition="fade-transition"
      :value="success"
      type="success"
    >
      Sparat!
    </v-alert>
    <v-alert
      :value="error"
      type="error"
    >
      Något gick fel!
    </v-alert>
  </v-card>
</template>

<script>
import api from '@/backend/api'
import log from '@/logger'

export default {
  name:'Placard',
  data: () => ({
    rules:{notNull(lop){
      if(lop.newAmount !== null){
        return true     
      }
      return 'Måste ange ett värde.'
      
    }},
    price: 0,
    errors: {},    
    lop:{},
    saving:false,
    success:false,
    error:false,
    valid:true
  }),
  computed:{   
   
  },
  mounted(){
    this.loadData()
  },
  methods: {
    loadData() {
      api.getPlacards().then((resp) => {
        log.debug('Resp placard:', resp.data)
        this.lop = resp.data
      })
      .catch(error => {          
          log.debug('Errors:', error)
        })  
    },
    validate() {
      let valid = false
      valid = this.lop.placards.every(l=>l.newAmount !== null)

      return valid
    },  
    spara(){
      if(this.validate() && !this.saving){      
      this.saving = true
      this.success = false
      this.error =false
      api.savePlacard(this.lop).then(resp=>{
        log.debug('Resp:', resp.data)
        this.success = true
      })
      .catch(error => {          
          log.debug('Errors:', error)          
          this.error= true
        })  
        .finally(() => {  
            this.saving= false        
          })
        }
    },
    amount(l){
      return l.newAmount??l.amount
    }
  }
}
</script>

<style>
.v-input__slot label {
    font-size: 0.8em;
}
.v-list-item__title{
  font-size: 1.4em;
}
</style>